@file:OptIn(InternalResourceApi::class)

package me.tbsten.compose.preview.lab.ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/me.tbsten.compose.preview.lab.ui.generated.resources/"

@delegate:ResourceContentHash(-609_913_370)
public val PreviewLabUiRes.drawable.icon_add: DrawableResource by lazy {
      DrawableResource("drawable:icon_add", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_add.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-708_534_458)
public val PreviewLabUiRes.drawable.icon_arrow_drop_down: DrawableResource by lazy {
      DrawableResource("drawable:icon_arrow_drop_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_arrow_drop_down.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_581_438_614)
public val PreviewLabUiRes.drawable.icon_check: DrawableResource by lazy {
      DrawableResource("drawable:icon_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_check.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_526_041_378)
public val PreviewLabUiRes.drawable.icon_close: DrawableResource by lazy {
      DrawableResource("drawable:icon_close", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_close.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(874_666_075)
public val PreviewLabUiRes.drawable.icon_code: DrawableResource by lazy {
      DrawableResource("drawable:icon_code", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_code.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_593_324_845)
public val PreviewLabUiRes.drawable.icon_dashboard: DrawableResource by lazy {
      DrawableResource("drawable:icon_dashboard", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_dashboard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(520_348_816)
public val PreviewLabUiRes.drawable.icon_delete: DrawableResource by lazy {
      DrawableResource("drawable:icon_delete", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_delete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_298_828_397)
public val PreviewLabUiRes.drawable.icon_edit: DrawableResource by lazy {
      DrawableResource("drawable:icon_edit", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_edit.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_303_308_559)
public val PreviewLabUiRes.drawable.icon_history: DrawableResource by lazy {
      DrawableResource("drawable:icon_history", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_history.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-231_597_083)
public val PreviewLabUiRes.drawable.icon_more_vert: DrawableResource by lazy {
      DrawableResource("drawable:icon_more_vert", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_more_vert.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_039_301_956)
public val PreviewLabUiRes.drawable.icon_refresh: DrawableResource by lazy {
      DrawableResource("drawable:icon_refresh", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_refresh.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-977_620_555)
public val PreviewLabUiRes.drawable.icon_remove: DrawableResource by lazy {
      DrawableResource("drawable:icon_remove", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_remove.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-81_310_833)
public val PreviewLabUiRes.drawable.icon_right_panel_close: DrawableResource by lazy {
      DrawableResource("drawable:icon_right_panel_close", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_right_panel_close.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-830_272_336)
public val PreviewLabUiRes.drawable.icon_right_panel_open: DrawableResource by lazy {
      DrawableResource("drawable:icon_right_panel_open", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_right_panel_open.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-350_762_120)
public val PreviewLabUiRes.drawable.icon_screenshot_frame: DrawableResource by lazy {
      DrawableResource("drawable:icon_screenshot_frame", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_screenshot_frame.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_017_429_747)
public val PreviewLabUiRes.drawable.icon_tune: DrawableResource by lazy {
      DrawableResource("drawable:icon_tune", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_tune.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_345_515_899)
public val PreviewLabUiRes.drawable.icon_zoom_in: DrawableResource by lazy {
      DrawableResource("drawable:icon_zoom_in", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_zoom_in.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(217_428_559)
public val PreviewLabUiRes.drawable.icon_zoom_out: DrawableResource by lazy {
      DrawableResource("drawable:icon_zoom_out", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_zoom_out.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("icon_add", PreviewLabUiRes.drawable.icon_add)
  map.put("icon_arrow_drop_down", PreviewLabUiRes.drawable.icon_arrow_drop_down)
  map.put("icon_check", PreviewLabUiRes.drawable.icon_check)
  map.put("icon_close", PreviewLabUiRes.drawable.icon_close)
  map.put("icon_code", PreviewLabUiRes.drawable.icon_code)
  map.put("icon_dashboard", PreviewLabUiRes.drawable.icon_dashboard)
  map.put("icon_delete", PreviewLabUiRes.drawable.icon_delete)
  map.put("icon_edit", PreviewLabUiRes.drawable.icon_edit)
  map.put("icon_history", PreviewLabUiRes.drawable.icon_history)
  map.put("icon_more_vert", PreviewLabUiRes.drawable.icon_more_vert)
  map.put("icon_refresh", PreviewLabUiRes.drawable.icon_refresh)
  map.put("icon_remove", PreviewLabUiRes.drawable.icon_remove)
  map.put("icon_right_panel_close", PreviewLabUiRes.drawable.icon_right_panel_close)
  map.put("icon_right_panel_open", PreviewLabUiRes.drawable.icon_right_panel_open)
  map.put("icon_screenshot_frame", PreviewLabUiRes.drawable.icon_screenshot_frame)
  map.put("icon_tune", PreviewLabUiRes.drawable.icon_tune)
  map.put("icon_zoom_in", PreviewLabUiRes.drawable.icon_zoom_in)
  map.put("icon_zoom_out", PreviewLabUiRes.drawable.icon_zoom_out)
}
